import React from 'react';
import { Modal } from 'antd';
import '@google/model-viewer';
import './FoodModal.css';

const FoodModal = ({ isVisible, image, onClose }) => {
  return (
    <Modal
      visible={isVisible}
      footer={null}
      destroyOnClose={true}
      onCancel={onClose}
      centered
      className={image?.includes('.webp') ? 'food-modal-with-webp' : 'food-modal-with-model width-max-content no-padding'}
    >
      {image?.includes('.webp') ? (
        <img src={image} alt={image} className='food-modal-image' />
      ) : (
        <model-viewer
          src={image}
          alt='A 3D model'
          auto-rotate
          auto-rotate-delay='0'
          camera-controls
          className='model-viewer custom-model-viewer'
          camera-orbit='0deg 45deg'
          min-camera-orbit='auto 0deg 6m'
          max-camera-orbit='auto 110deg 7m'
          rotation-per-second='10deg'
        />
      )}
    </Modal>
  );
};

export default FoodModal;
